import { render, staticRenderFns } from "./ColumnContentIcon.vue?vue&type=template&id=3b128010&scoped=true&"
import script from "./ColumnContentIcon.vue?vue&type=script&lang=js&"
export * from "./ColumnContentIcon.vue?vue&type=script&lang=js&"
import style0 from "./ColumnContentIcon.vue?vue&type=style&index=0&id=3b128010&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b128010",
  null
  
)

export default component.exports